import React from 'react'
import styled from 'styled-components'
import { Link } from '@reach/router'
import { StyledButton, StyledHeader } from './styles'

export default function Intro() {
  return (
    <StyledIntro>
      <StyledHeader>TV SHOW RATINGS QUIZ!</StyledHeader>
      <StyledIntroText>
        Do you know the show which ratings plummetted in its last season? 💥 Or
        the one that just kept rising and rising? 🚀
      </StyledIntroText>
      <StyledIntroText>
        This is the quiz where your knowledge <b>finally</b> becomes useful!
        Guess the TV show based on its ratings!
      </StyledIntroText>
      <StyledButton width="200px" as={Link} to="play">
        Play 5 questions!
      </StyledButton>
      <StyledFooter>
        Made by <a href="https://twitter.com/awnton">Anton</a>
      </StyledFooter>
    </StyledIntro>
  )
}

const StyledIntro = styled.div`
  font-family: 'Helvetica', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

const StyledIntroText = styled.p`
  max-width: 350px;
  font-size: 18px;
  margin: 0 0 18px 0;
`

const StyledFooter = styled.p`
  margin-top: auto;
  color: rgba(255, 255, 255, 0.8);

  a {
    color: rgba(255, 255, 255, 0.8);

    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
`
